// Klant = Custiomer (customer of BioQ)
// Labinstument = Device identification
// Robot naam = Instument – product type
// Robot fabrikant naam = IVD Manufacturer

import { Action, Reducer } from 'redux';
import { AppThunkAction } from '.';
import LabEquipmentApi from '../components/lab-equipment/utils/labEquipmentApi';

export interface DeviceData {
    Customer_No: string;
    Lab_Instrument_code: string;
    Robot_Name: string;
    Robot_Code: string;
    Robot_Manufacturer_Name: string;
    Robot_Manufacturer_Code: string;
    Method_group: string;
    Method_Test_Group: string;
    Method_description: string;
    Lab_Instrument_blocked: boolean;
}

interface FetchLabEquipment {
    type: 'FETCH_LAB_EQUIPMENT';
    payload: DeviceData[];
}

type KnownAction = FetchLabEquipment;

export const actionCreators = {
    fetchLabEquipment:
        (customerId?: number): AppThunkAction<FetchLabEquipment> =>
        async (dispatch) => {
            const response = await LabEquipmentApi.getLabEquipment();

            dispatch({
                type: 'FETCH_LAB_EQUIPMENT',
                payload: response.value,
            });
        }
};

export const reducer: Reducer<DeviceData[]> = (
    state: DeviceData[] = [],
    incomingAction: Action
): DeviceData[] => {
    const action = incomingAction as KnownAction;

    switch (action.type) {
        case 'FETCH_LAB_EQUIPMENT':
            return action.payload;
        default:
            return state;
    }
};
